<div class="playbook-projection">
  <div class="title">{{ 'playbooks.projection.title' | labelsProvider }}</div>
  @if (!hasAllRequiredInputs()) {
    <div class="disclaimer">{{ 'playbooks.projection.missingTrigger' | labelsProvider }}</div>
  } @else if (!isBrownfieldTrigger()) {
    <div class="disclaimer">{{ 'playbooks.projection.insightsNotAvailable' | labelsProvider }}</div>
  } @else if (isLoading()) {
    <div class="spinner">
      <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
    </div>
  } @else {
    <div
      class="count"
      [class.clickable]="isExplorationAvailable()"
      (click)="isExplorationAvailable() && onClick()"
      [matTooltip]="
        isExplorationAvailable()
          ? ''
          : ((isViolationTrigger()
              ? 'playbooks.projection.violationExplorationNotAvailable'
              : 'playbooks.projection.resourceExplorationNotAvailable'
            ) | labelsProvider)
      "
    >
      {{ projectionCount() }}
    </div>
    <div
      class="subtitle"
      [matTooltip]="
        (isViolationTrigger()
          ? 'playbooks.projection.totalViolationsTooltip'
          : 'playbooks.projection.totalResourcesTooltip'
        ) | labelsProvider
      "
    >
      {{
        (isViolationTrigger() ? 'playbooks.projection.totalViolations' : 'playbooks.projection.totalResources')
          | labelsProvider
      }}
    </div>
  }
</div>
